var _path, _path2, _path3, _path4, _defs, _defs2, _defs3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHaha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1,0)",
    d: "M16.999 8.00001C16.999 9.05065 16.7921 10.091 16.39 11.0617C15.988 12.0323 15.3987 12.9143 14.6558 13.6572C13.9128 14.4001 13.0309 14.9894 12.0602 15.3915C11.0895 15.7936 10.0492 16.0005 8.99855 16.0005C7.94791 16.0005 6.90755 15.7936 5.93689 15.3915C4.96622 14.9894 4.08425 14.4001 3.34134 13.6572C2.59842 12.9143 2.00911 12.0323 1.60705 11.0617C1.20499 10.091 0.998047 9.05065 0.998047 8.00001C0.998047 5.87815 1.84095 3.84319 3.34134 2.3428C4.84172 0.842419 6.87668 -0.000488281 8.99855 -0.000488281C11.1204 -0.000488281 13.1554 0.842419 14.6558 2.3428C16.1561 3.84319 16.999 5.87815 16.999 8.00001Z",
    fill: "url(#paint0_linear_10487_17712)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3,3)",
    d: "M3.21297 1.14378C3.47597 1.33178 3.71497 1.59878 3.62297 1.93178C3.55197 2.18578 3.42897 2.30078 3.20097 2.30178C2.42097 2.31378 1.49297 2.55778 0.694969 2.91478C0.629969 2.94378 0.497969 3.00278 0.362969 2.99978C0.238969 2.99678 0.111969 2.94178 0.0359694 2.76278C-0.0310306 2.60578 -0.0370306 2.37478 0.311969 2.16478C0.856969 1.83478 1.56897 1.68478 2.22097 1.56078C1.81097 1.25778 1.37097 1.00078 0.905969 0.792783C0.478969 0.598783 0.525969 0.335783 0.582969 0.192783C0.709969 -0.124217 1.19197 -0.00321698 1.66097 0.218783C2.20802 0.474277 2.72797 0.784172 3.21297 1.14378ZM6.78997 1.14378C7.27416 0.784032 7.79347 0.474125 8.33997 0.218783C8.80997 -0.00321698 9.28997 -0.124217 9.41797 0.192783C9.47497 0.335783 9.52197 0.598783 9.09497 0.792783C8.63081 1.00053 8.19056 1.25803 7.78197 1.56078C8.43197 1.68378 9.14497 1.83478 9.68897 2.16478C10.038 2.37478 10.031 2.60478 9.96497 2.76278C9.88797 2.94278 9.76197 2.99678 9.63797 2.99978C9.50297 3.00278 9.37097 2.94378 9.30597 2.91478C8.50897 2.55778 7.58097 2.31478 6.80197 2.30278C6.57397 2.30078 6.45097 2.18578 6.37997 1.93278C6.28897 1.59978 6.52697 1.33178 6.78997 1.14378Z",
    fill: "#2A3755"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3,7)",
    d: "M0 1.008C0 3.023 1.006 7 5 7C8.993 7 10 3.023 10 1.008C10 0.849 8.39 0 5 0C1.61 0 0 0.849 0 1.008Z",
    fill: "url(#paint0_linear_10487_17713)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(4,11)",
    d: "M0.541016 1.5C1.34502 2.495 2.44802 3 4.01002 3C5.57302 3 6.66502 2.495 7.46902 1.5C6.91802 0.912 5.87002 0 4.01002 0C2.15002 0 1.09302 0.912 0.541016 1.5Z",
    fill: "url(#paint0_linear_10487_17714)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10487_17714",
    x1: 4.00502,
    y1: 0,
    x2: 4.00502,
    y2: 2.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC607C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D91F3A"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10487_17713",
    x1: 5,
    y1: 0,
    x2: 5,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#472315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B3A0E"
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10487_17712",
    x1: 8.99905,
    y1: 1.64001,
    x2: 8.99905,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69B30"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaha);
export default __webpack_public_path__ + "static/media/haha.53a44420ae47b712908d1d2570145c31.svg";
export { ForwardRef as ReactComponent };